module.exports = "<!-- preloader start -->\n<div id=\"tb-preloader\">\n  <div class=\"tb-preloader-wave\"></div>\n</div>\n<!-- preloader end -->\n\n<div class=\"wrapper\">\n\n  <app-header></app-header>\n\n  <app-hero></app-hero>\n\n  <app-body></app-body>\n\n  <app-footer1></app-footer1>\n</div>"


//////////////////
// WEBPACK FOOTER
// G:/proyectos/website - IntergraMAI/webMai/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 1